import * as Styled from './List.styled';
import type { ListProps } from './List.types';
import React from 'react';

const List = React.forwardRef<HTMLUListElement, ListProps>((props, ref) => {
  const { children, divider = '•', dividerColor = '#666666' } = props;
  return (
    <Styled.List ref={ref} divider={divider} dividerColor={dividerColor}>
      {children
        .filter((item) => !!item)
        .map((item, index) => (
          <li key={index}>{item}</li>
        ))}
    </Styled.List>
  );
});

export default List;
